export default "__VITE_ASSET__B_3v$z9p__"